import { VariantConfirmation } from './types';

export function formatDate(iso: string | null | undefined): string {
  if (!iso) return '';
  return new Date(iso).toLocaleDateString('en-US', {
    month: 'short',
    day: '2-digit',
    year: 'numeric',
  });
}

export function booleanToYesNo(value: boolean | null | undefined): string {
  if (value === true) return 'Yes';
  if (value === false) return 'No';
  return '';
}

export function getNomenclatureNames(
  nomenclatures: VariantConfirmation['variant']['nomenclatures'],
  type: string,
  primaryOnly: boolean = false,
  shortName: boolean = false
): string {
  let filtered = nomenclatures.filter((n) => n.is_primary && n.type === type);
  if (!primaryOnly) {
    filtered = filtered.concat(nomenclatures.filter((n) => !n.is_primary && n.type === type));
  }
  return filtered
    .map((n) => {
      if (!shortName) return n.name;
      const pos = n.name.indexOf(':');
      return pos >= 0 ? n.name.substring(pos + 1) : n.name;
    })
    .join(', ');
}
